import styled from 'styled-components';

export default styled.div`
  font-size: 18px;

  .background {
    position: fixed;
    background-color: rgba(255, 255, 255, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }

  .modal {
    background-color: ${(props) => props.theme.colors.grey};
    padding: 20px;
    position: relative;
    max-width: 750px;
    width: 100%;
    min-height: 210px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    .delete {
      position: absolute;
      width: 19px;
      height: 19px;
      right: 13px;
      top: 13px;
      cursor: pointer;
    }
  }
`;
